import { BFF_API_ROUTES } from 'constants/apiRoutes';

import { baseRTKApi } from 'shared/api/baseApi';

import type { TEssentialCreditStatus } from '../types';

export const essentialCreditStatusQueries = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getEssentialCreditStatus: build.query<TEssentialCreditStatus, void>({
      query: () => BFF_API_ROUTES.getEssentialCreditStatus,
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useGetEssentialCreditStatusQuery } = essentialCreditStatusQueries;
